import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {HttpUtils} from "../shared/http.utils";
import {CsvHistoryFilters} from "../model/filters/csv-history-filters";
import {CsvHistoryResponse} from "../model/responses/csv-history-response";

@Injectable({
  providedIn: 'root'
})
export class CsvHistoryService {

  private readonly csvHistoryURL: string;

  constructor(private http: HttpClient) {
    this.csvHistoryURL = "/catalog/csv-history";
  }

  public getCsvHistory(offset?: number, limit?: number, filters?: CsvHistoryFilters): Observable<CsvHistoryResponse> {
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let body = (filters != null) ? filters : new CsvHistoryFilters();
    return this.http.post<CsvHistoryResponse>(this.csvHistoryURL, body, options);
  }

}
